export default function message(msg = false) {
	if (!msg) {
		// const el = document.querySelector(".card-root");
		// if (!el) {
		// return window.parent.postMessage(600, "*");
		// }
		const root = document.querySelector("#root");
		if (root) {
			const rootHeight = root.offsetHeight + 30;
			window.parent.postMessage(rootHeight, "*");
		} else {
			window.parent.postMessage(600, "*");
		}
		// window.parent.postMessage(document.documentElement.offsetHeight, '*')
	} else {
		window.parent.postMessage(msg, "*");
	}
}
